import axios from 'axios'
import { VENDA_SEGURO_HABILITADA} from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';

const CACHE_PREFIX = 'vexado_seguro_habilitado_';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function vendaSeguroHabilitada (idEmpresa) {
  const url = `${URL}/reserva/empresa/${idEmpresa}/venda-seguro-habilitada`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      try { localStorage.setItem(`${CACHE_PREFIX}${idEmpresa}`, JSON.stringify(response.data)); } catch (_) { // ignore
      }
      return dispatch({ type: VENDA_SEGURO_HABILITADA, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        try {
          const cache = localStorage.getItem(`${CACHE_PREFIX}${idEmpresa}`);
          if (cache !== null) return dispatch({ type: VENDA_SEGURO_HABILITADA, payload: { data: JSON.parse(cache) } });
        } catch (_) { // ignore
        }
        return dispatch({ type: VENDA_SEGURO_HABILITADA, payload: { data: false } });
      }
      throw erro;
    });
}
